import { render } from "./App.vue?vue&type=template&id=3e774b52"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3e774b52&lang=css"

import exportComponent from "/codebuild/output/src1815703633/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__